import React from 'react';
import Card from '../../../../core/layout/Card';
import Separator from '../../../../core/layout/Separator';
import UnitItemExecutionStatsListFilterContainer from './UnitItemExecutionStatsListFilterContainer';
import UnitItemExecutionStatsListContainer from './UnitItemExecutionStatsListContainer';

const UnitItemExecutionStatsListScene = () => (
  <div>
    <Card>
      <UnitItemExecutionStatsListFilterContainer />
    </Card>
    <Separator />
    <Card
      title="Unit Items Execution Stats"
      actions={<label>Data based on last 60 days, limited to the 500 most recent executions</label>}
    >
      <UnitItemExecutionStatsListContainer />
    </Card>
  </div>
);

export default UnitItemExecutionStatsListScene;
